import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {Trans} from "../utils/i18n";
import {useField} from "react-final-form";
import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "../utils/axiosClient";
import {useFormState} from "./FormState";

export const useEmptyBoxConfigQuery = ({requesttype, product_id}) => {
    return useQuery({
        queryKey: ["emptyBoxConfig", requesttype, product_id],
        queryFn: async () => {
            const response = await axiosClient.post(route("empty-box.match"), {
                requesttype,
                product_id,
            });
            return response.data;
        },
    });
};

export default function EmptyBoxCheckbox({ values }) {
    const { requesttype } = values;
    const orderEntryState = useFormState();
    const product = orderEntryState.selectedProduct;
    const { input, meta, } = useField("send_empty_box", {
        type: "checkbox",
    });

    const { data, isLoading, isError } = useEmptyBoxConfigQuery({
        requesttype,
        product_id: product?.id,
    });

    if ((data && !data.success) || isError || !data?.data?.empty_box_allowed) {
        return null;
    }

    return (
        <FormControl
            //error={touched && error}
            variant="outlined"
        >
            <FormControlLabel
                control={
                    <Checkbox
                        name={"send_empty_box"}
                        id={'checkbox'}
                        disabled={isLoading}
                        {...input}
                    />
                }
                label={<Trans i18nKey="orderEntry.send_empty_box.label">Please send me an empty box.</Trans>}
            />
        </FormControl>
    );
}

